<template>
    <div class="sc-upload-multiple">
        <div class="sc-upload-list">
            <ul v-if="imgList">
                <li v-for="(file, index) in imgList" :key="index">
                    <div class="sc-upload-item">
                        <el-image class="image" :src="file.ioURL? file.ioURL: file" fit="cover" :preview-src-list="preview" hide-on-click-modal append-to-body>
                            <template #placeholder>
                                <div class="image-slot">
                                    <el-icon>
                                        <el-icon-more-filled />
                                    </el-icon>
                                </div>
                            </template>
                        </el-image>
                    </div>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>

export default {
    props: {
        list: { type: Array, default: () => { [] } },
    },
    data () {
        return {
            value: "",
            defaultFileList: [],
            imgList: [],
            fileSelectDialogVisible: false,
        };
    },
    watch: {
        list: {
            handler () {
                this.imgList = this.list || []
            },
            deep: true,
            immediate: true
        },
    },
    computed: {
        preview () {
            return this.imgList.map((file) => file.ioURL ? file.ioURL : file);
        },
    },
};
</script>

<style scoped>
.el-form-item.is-error .sc-upload-uploader {
    border: 1px dashed #f56c6c;
}

.sc-upload-multiple {
    display: inline-block;
}

.sc-upload-list {
    display: block;
}
.sc-upload-list li {
    list-style: none;
    display: inline-block;
    width: 80px;
    height: 80px;
    margin-right: 10px;
    margin-bottom: 10px;
    vertical-align: top;
    box-sizing: border-box;
}

.sc-upload-item {
    position: relative;
    width: 100%;
    height: 100%;
}
.sc-upload-item .mask {
    display: none;
    position: absolute;
    top: 0px;
    right: 0px;
    line-height: 1;
    z-index: 1;
}
.sc-upload-item .mask span {
    display: inline-block;
    width: 25px;
    height: 25px;
    line-height: 23px;
    text-align: center;
    cursor: pointer;
    color: #fff;
}
.sc-upload-item .mask span i {
    font-size: 12px;
}
.sc-upload-item .mask .del {
    background: #f56c6c;
}

.sc-upload-item:hover .mask {
    display: inline-block;
}

.sc-upload-list .image {
    width: 100%;
    height: 100%;
}

.sc-upload-list .image-slot {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    background: #f5f7fa;
    color: #909399;
}
.sc-upload-list .image-slot i {
    font-size: 20px;
}

.sc-upload-uploader {
    border: 1px dashed #d9d9d9;
    width: 140px;
    height: 34px;
    display: block;
    margin-bottom: 10px;
    vertical-align: top;
    box-sizing: border-box;
}
.sc-upload-uploader:hover {
    border: 1px dashed #409eff;
}
.sc-upload-uploader .uploader {
    width: 100%;
    height: 100%;
}
.sc-upload-uploader:deep(.el-upload) {
    width: 100%;
    height: 100%;
}

.sc-upload-uploader .file-empty {
    width: 100%;
    height: 100%;
    line-height: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}
.sc-upload-uploader .file-empty i {
    font-size: 28px;
    color: #8c939d;
}
.sc-upload-uploader .file-empty h4 {
    font-size: 12px;
    font-weight: normal;
    color: #8c939d;
    margin-top: 10px;
}
</style>
